// Generated from docs/nope-badges/badges.config.js (+ legacy shapes from the prototype).
// Regenerate with the gen-badge-art script instead of hand-editing paths.
import { BadgeShape, BadgeShapeKey } from './types.js'

export const BADGE_SHAPES: Record<BadgeShapeKey, BadgeShape> = {
    bookmark: {
        label: { et: 'järjehoidja', en: 'bookmark' },
        d: 'M28,30Q28,10 48,10L152,10Q172,10 172,30L172,182Q172,194 161.51,188.17L113.99,161.77Q100,154 86.01,161.77L38.49,188.17Q28,194 28,182Z',
        icon: [100, 83.5, 1.22],
        inset: [18, 50, 56],
    },
    star6: {
        label: { et: 'kuueharuline täht', en: 'six-point star' },
        d: 'M88.21,12.81Q100,2 111.79,12.81L125.21,25.1Q137,35.91 152.26,40.72L169.61,46.19Q184.87,51 181.41,66.62L177.47,84.38Q174,100 177.47,115.62L181.41,133.38Q184.87,149 169.61,153.81L152.26,159.28Q137,164.09 125.21,174.9L111.79,187.19Q100,198 88.21,187.19L74.79,174.9Q63,164.09 47.74,159.28L30.39,153.81Q15.13,149 18.59,133.38L22.53,115.62Q26,100 22.53,84.38L18.59,66.62Q15.13,51 30.39,46.19L47.74,40.72Q63,35.91 74.79,25.1Z',
        icon: [100, 99.5, 1.06],
        inset: [18, 50, 56],
    },
    drop: {
        label: { et: 'tilk', en: 'drop' },
        d: 'M91,18Q100,4 109,18C132,52 180,84 180,118A80,80 0 0 1 20,118C20,84 68,52 91,18Z',
        icon: [100, 122.3, 1.1],
        inset: [18, 50, 56],
    },
    cloud: {
        label: { et: 'pilv', en: 'cloud' },
        d: 'M56,172A46,46 0 0 1 40.08,82.84A60,60 0 0 1 159.92,82.84A46,46 0 0 1 144,172Z',
        icon: [100, 107, 1.08],
        inset: [16, 40, 45],
    },
    ticket: {
        label: { et: 'pilet', en: 'ticket' },
        d: 'M36,28H164Q184,28 184,48V80A20,20 0 0 0 184,120V152Q184,172 164,172H36Q16,172 16,152V120A20,20 0 0 0 16,80V48Q16,28 36,28Z',
        icon: [100, 99.4, 1.16],
        inset: [18, 50, 56],
    },
    sun: {
        label: { et: 'päike', en: 'sun' },
        d: 'M96.41,3.48Q100,0 103.59,3.48L115.1,14.63Q118.69,18.11 123.44,16.53L138.64,11.48Q143.39,9.9 145.11,14.6L150.65,29.63Q152.37,34.33 157.33,34.96L173.22,37.01Q178.18,37.65 177.7,42.63L176.16,58.58Q175.68,63.55 179.87,66.28L193.3,75.02Q197.49,77.75 194.9,82.02L186.59,95.72Q184,100 186.59,104.28L194.9,117.98Q197.49,122.25 193.3,124.98L179.87,133.72Q175.68,136.45 176.16,141.42L177.7,157.37Q178.18,162.35 173.22,162.99L157.33,165.04Q152.37,165.67 150.65,170.37L145.11,185.4Q143.39,190.1 138.64,188.52L123.44,183.47Q118.69,181.89 115.1,185.37L103.59,196.52Q100,200 96.41,196.52L84.9,185.37Q81.31,181.89 76.56,183.47L61.36,188.52Q56.61,190.1 54.89,185.4L49.35,170.37Q47.63,165.67 42.67,165.04L26.78,162.99Q21.82,162.35 22.3,157.37L23.84,141.42Q24.32,136.45 20.13,133.72L6.7,124.98Q2.51,122.25 5.1,117.98L13.41,104.28Q16,100 13.41,95.72L5.1,82.02Q2.51,77.75 6.7,75.02L20.13,66.28Q24.32,63.55 23.84,58.58L22.3,42.63Q21.82,37.65 26.78,37.01L42.67,34.96Q47.63,34.33 49.35,29.63L54.89,14.6Q56.61,9.9 61.36,11.48L76.56,16.53Q81.31,18.11 84.9,14.63Z',
        icon: [100, 100, 1],
        inset: [18, 50, 56],
    },
    bubble: {
        label: { et: 'jutumull', en: 'speech bubble' },
        d: 'M94.39,18.31Q100,18 105.61,18.31L105.61,18.31Q111.23,18.62 116.74,19.53L116.74,19.53Q122.26,20.45 127.58,21.97L127.58,21.97Q132.91,23.48 137.96,25.56L137.96,25.56Q143,27.65 147.68,30.26L147.68,30.26Q152.35,32.88 156.58,35.98L156.58,35.98Q160.81,39.09 164.52,42.63L164.52,42.63Q168.23,46.17 171.35,50.08L171.35,50.08Q174.48,54 176.97,58.22L176.97,58.22Q179.45,62.45 181.26,66.91L181.26,66.91Q183.07,71.37 184.17,75.98L184.17,75.98Q185.26,80.6 185.63,85.3L185.63,85.3Q186,90 185.63,94.7L185.63,94.7Q185.26,99.4 184.17,104.02L184.17,104.02Q183.07,108.63 181.26,113.09L181.26,113.09Q179.45,117.55 176.97,121.78L176.97,121.78Q174.48,126 171.35,129.92L171.35,129.92Q168.23,133.83 164.52,137.37L164.52,137.37Q160.81,140.91 156.58,144.02L156.58,144.02Q152.35,147.12 147.68,149.74L147.68,149.74Q143,152.35 137.96,154.44L137.96,154.44Q132.91,156.52 127.58,158.03L127.58,158.03Q122.26,159.55 116.74,160.47L116.74,160.47Q111.23,161.38 105.61,161.69L105.61,161.69Q100,162 94.04,161.3L88.15,160.61Q76.3,159.21 66.01,165.39L39.43,181.34Q30,187 32.43,176.27L37.6,153.49Q40.26,141.79 32.89,133.9L29.62,130.39Q25.52,126 23.03,121.78L23.03,121.78Q20.55,117.55 18.74,113.09L18.74,113.09Q16.93,108.63 15.83,104.02L15.83,104.02Q14.74,99.4 14.37,94.7L14.37,94.7Q14,90 14.37,85.3L14.37,85.3Q14.74,80.6 15.83,75.98L15.83,75.98Q16.93,71.37 18.74,66.91L18.74,66.91Q20.55,62.45 23.03,58.22L23.03,58.22Q25.52,54 28.65,50.08L28.65,50.08Q31.77,46.17 35.48,42.63L35.48,42.63Q39.19,39.09 43.42,35.98L43.42,35.98Q47.65,32.88 52.32,30.26L52.32,30.26Q57,27.65 62.04,25.56L62.04,25.56Q67.09,23.48 72.42,21.97L72.42,21.97Q77.74,20.45 83.26,19.53L83.26,19.53Q88.77,18.62 94.39,18.31Z',
        icon: [100, 90, 1.12],
        inset: [16, 40, 45],
    },
    arch: {
        label: { et: 'kaar', en: 'arch' },
        d: 'M42,192Q24,192 24,174V96A76,76 0 0 1 176,96V174Q176,192 158,192Z',
        icon: [100, 105.8, 1.18],
        inset: [18, 50, 56],
    },
    diamond: {
        label: { et: 'romb', en: 'diamond' },
        d: 'M80.2,23.8Q100,4 119.8,23.8L176.2,80.2Q196,100 176.2,119.8L119.8,176.2Q100,196 80.2,176.2L23.8,119.8Q4,100 23.8,80.2Z',
        icon: [100, 100, 1.02],
        inset: [18, 50, 56],
    },
    quatrefoil: {
        label: { et: 'ristik', en: 'quatrefoil' },
        d: 'M52.34,52.34A48,48 0 0 1 147.66,52.34A48,48 0 0 1 147.66,147.66A48,48 0 0 1 52.34,147.66A48,48 0 0 1 52.34,52.34Z',
        icon: [100, 100, 1.1],
        inset: [18, 50, 56],
    },
    shield: {
        label: { et: 'kilp', en: 'shield' },
        d: 'M42,18H158Q176,18 176,36V100C176,146 142,174 100,194C58,174 24,146 24,100V36Q24,18 42,18Z',
        icon: [100, 97.8, 1.18],
        inset: [18, 50, 56],
    },
    ringmedal: {
        label: { et: 'aastaring', en: 'year ring' },
        d: 'M8,100a92,92 0 1,0 184,0a92,92 0 1,0 -184,0Z',
        icon: [100, 100, 1],
        inset: [16, 44, 48],
        noLine: true,
    },
    square: {
        label: { et: 'ruut', en: 'square' },
        d: 'M20,56Q20,20 56,20L144,20Q180,20 180,56L180,144Q180,180 144,180L56,180Q20,180 20,144Z',
        icon: [100, 100, 1.28],
        inset: [18, 50, 56],
    },
    triangle: {
        label: { et: 'kolmnurk', en: 'triangle' },
        d: 'M86.04,36.27Q100,12 113.96,36.27L178.04,147.73Q192,172 164,172L36,172Q8,172 21.96,147.73Z',
        icon: [100, 117.8, 0.9],
        inset: [16, 38, 43],
    },
    wedge: {
        label: { et: 'sektor', en: 'wedge' },
        d: 'M92,22Q100,6 108,22L180,150Q188,168 168,172A170,170 0 0 1 32,172Q12,168 20,150Z',
        icon: [100, 126.2, 0.9],
        inset: [16, 38, 43],
    },
    circle: {
        label: { et: 'ring', en: 'circle' },
        d: 'M8,100a92,92 0 1,0 184,0a92,92 0 1,0 -184,0Z',
        icon: [100, 100, 1.3],
        inset: [18, 50, 56],
    },
    star5: {
        label: { et: 'viisnurk', en: 'five-point star' },
        d: 'M92.78,20Q100,8 107.22,20L125.7,50.7Q132.92,62.7 146.55,65.85L181.47,73.94Q195.11,77.1 185.93,87.67L162.44,114.73Q153.26,125.3 154.47,139.25L157.57,174.95Q158.78,188.9 145.89,183.44L112.89,169.46Q100,164 87.11,169.46L54.11,183.44Q41.22,188.9 42.43,174.95L45.53,139.25Q46.74,125.3 37.56,114.73L14.07,87.67Q4.89,77.1 18.53,73.94L53.45,65.85Q67.08,62.7 74.3,50.7Z',
        icon: [100, 107.4, 0.8],
        inset: [16, 36, 41],
    },
    heart: {
        label: { et: 'süda', en: 'heart' },
        d: 'M100,184C42,146 8,112 8,72C8,38 32,16 62,16C80,16 93,26 100,40C107,26 120,16 138,16C168,16 192,38 192,72C192,112 158,146 100,184Z',
        icon: [100, 88, 1],
        inset: [18, 44, 48],
        noLine: true,
    },
}
